import style from './index.module.styl'
// import logoImg from './logo.png'
// const loadingTextImage = 'https://hdcdn.shenhudong.com/public/img/shdLogo/shd.png'

export default {
  name: 'Loading',
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    imgSrc: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  render(h, context) {
    return (
      <div class={{[style['loading-mask']]: true, [style['white-mask']]: this.fixed}} v-show={this.show}>
        <div class={style['logo']}>
          {
            this.imgSrc ? (
              <img src={this.imgSrc} />
            ) : (
              <div class={style['null-box']}></div>
            )
          }
        </div>
        <span>Loading...</span>
      </div>
    )
  }
}